'use client';
import React from 'react';

import { GoogleIcon } from '@/assets/icons/external';
import { useGoogleLogin } from '@react-oauth/google';
import UtilityService from '@/services/util/utility-service';

const redirect_uri =
  process.env.NODE_ENV === 'development'
    ? process.env.NEXT_PUBLIC_API_URL_DEVELOPMENT
    : UtilityService.getApiUrl();

interface Props {
  isAdmin?: boolean;
  isSAML?: boolean;
}

function GoogleLoginButton({ isAdmin = false, isSAML = true }: Props): React.JSX.Element {
  const googleLogin = useGoogleLogin({
    flow: 'auth-code',
    ux_mode: 'redirect',
    redirect_uri: `${redirect_uri}auth/${isAdmin ? 'admin/' : ''}login`,
    state: JSON.stringify({ origin: window.location.origin }),
  });
  const SAMLLogin = (e: any) => {
    window.location.href = `${redirect_uri}auth/saml/login`;
  };

  return (
    <>
      <button
        onClick={isSAML && !isAdmin ? SAMLLogin : googleLogin}
        className='bg-white font-medium text-neutral-700 inline-flex items-center whitespace-nowrap rounded-xl shadow-[0px_2px_4px_rgba(0,0,0,0.5)] pl-[6px] pr-[14px] py-[5px] border-[none]'
      >
        <div className='w-[30px] h-[30px]'>
          <GoogleIcon />
        </div>
        Sign in with Google
      </button>
    </>
  );
}

export default GoogleLoginButton;
